const images = {
    feronLogo: '/images/feron-logo.png',
    profilePlaceholder: '/images/profile-placeholder.png',
    loginSplash: '/images/admin-splash.jpeg'
}
export default images
